import { useId } from 'react';
import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

/**
 * Стильная иконка Lensy — «сверкающая звезда» с градиентной заливкой.
 * Используется в хедере и в заголовке панели Lensy вместо обычного робота.
 *
 * gradId уникален на каждый экземпляр (useId): при фиксированном id браузер
 * резолвит `url(#id)` в ПЕРВЫЙ элемент с этим id в DOM (иконка в шапке). В
 * полноэкранном режиме таблицы шапка `display:none`, и градиент из скрытого
 * поддерева перестаёт отрисовываться — все остальные иконки Lensy становятся
 * пустыми. Уникальный id развязывает экземпляры между собой.
 */
function AiSparkSvg(): JSX.Element {
  const gradId = useId();
  return (
    <svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#14b8a6" />
          <stop offset="100%" stopColor="#0d9488" />
        </linearGradient>
      </defs>
      <path
        d="M12 2.5c.3 0 .56.18.67.46l1.53 3.82a4 4 0 0 0 2.22 2.22l3.82 1.53a.72.72 0 0 1 0 1.34l-3.82 1.53a4 4 0 0 0-2.22 2.22l-1.53 3.82a.72.72 0 0 1-1.34 0l-1.53-3.82a4 4 0 0 0-2.22-2.22L3.76 11.87a.72.72 0 0 1 0-1.34l3.82-1.53a4 4 0 0 0 2.22-2.22l1.53-3.82A.72.72 0 0 1 12 2.5z"
        fill={`url(#${gradId})`}
      />
      <circle cx="19.5" cy="5" r="1.3" fill={`url(#${gradId})`} opacity="0.85" />
      <circle cx="5" cy="19" r="1" fill={`url(#${gradId})`} opacity="0.75" />
    </svg>
  );
}

export function AiSparkIcon(props: Partial<CustomIconComponentProps>): JSX.Element {
  return <Icon component={AiSparkSvg} {...props} />;
}
